import apiClient from '../apiClient';
import { POST_PAYMENT_SCHEME_URL } from '../apiUrl';

const postPaymentSchemeApi = data => {
  return apiClient.post(POST_PAYMENT_SCHEME_URL, data);
};

export default postPaymentSchemeApi;
